import { useState, type FormEvent } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { errorMessage } from '../lib/errors';

export function LoginPage() {
  const { user, staff, loading, signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  if (!loading && user && staff) return <Navigate to="/" replace />;

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await signIn(email.trim(), password);
    } catch (caught) {
      setError(errorMessage(caught));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="login-layout">
      <section className="login-visual">
        <div className="login-brand">
          <div className="brand-mark large">F</div>
          <div>
            <strong>Findex</strong>
            <span>Console éditoriale</span>
          </div>
        </div>
        <div className="login-copy">
          <p className="eyebrow">Administration privée</p>
          <h1>Crée, contrôle et publie les énigmes sans mise à jour du store.</h1>
          <p>
            Les données restent dans Supabase. Les packs publiés sont téléchargés par l’application Findex.
          </p>
        </div>
      </section>

      <section className="login-panel">
        <form className="auth-card" onSubmit={submit}>
          <p className="eyebrow">Connexion</p>
          <h2>Accéder à Findex Admin</h2>
          <label>
            Adresse e-mail
            <input
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </label>
          <label>
            Mot de passe
            <input
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </label>
          {error && <div className="alert error">{error}</div>}
          <button className="button primary full" disabled={submitting}>
            {submitting ? 'Connexion…' : 'Se connecter'}
          </button>
        </form>
      </section>
    </main>
  );
}
